import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from './components/Layout';
import Home from './pages/Home';
// import Writing from './pages/Writing';
// import ArticleDetail from './pages/ArticleDetail';
import Photos from './pages/Photos';
import Movies from './pages/Movies';
import Travel from './pages/Travel';
import Projects from './pages/Projects';
import Software from './pages/Software';
import NotFound from './pages/NotFound';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/writing" element={<Writing />} />
            <Route path="/writing/:slug" element={<ArticleDetail />} /> */}
            <Route path="/photos" element={<Photos />} />
            <Route path="/movies" element={<Movies />} />
            <Route path="/travel" element={<Travel />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/software" element={<Software />} />
            <Route path="/lists/travel" element={<Travel />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
